// socket.service.js
import socketIOClient from 'socket.io-client';

const ENDPOINT = process.env.REACT_APP_baseUrl;

let socket = null;
let currentToken = null;

/**
 * Returns a singleton Socket.IO client, rebuilding it if the JWT changes.
 */
const getSocket = () => {
  const jwtToken = localStorage.getItem("jwtToken");
  if (!jwtToken) {
    console.warn("⚠️ No JWT token found in localStorage.");
    return null;
  }

  // If token changed, fully tear down the old socket
  if (socket && currentToken !== jwtToken) {
    socket.disconnect();
    socket = null;
  }

  // If we already have a healthy connection, return it
  if (socket && socket.connected) {
    return socket;
  }

  // Otherwise create a new one
  currentToken = jwtToken;
  socket = socketIOClient(ENDPOINT, {
    query: { authorization: jwtToken },
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,  // keep retrying
    reconnectionDelay: 1000,
  });

  // Debug logging
  socket.on("connect",    () => console.log("✅ Socket connected:",    socket.id));
  socket.on("disconnect", (reason) => console.warn("⚠️ Socket disconnected:", reason));
  socket.on("connect_error", (err) => console.error("❌ Socket error:", err.message));

  return socket;
};

/**
 * Emits an event; if not yet connected, queues it until 'connect' fires.
 */
const safeEmit = (event, data) => {
  const sock = getSocket();
  if (!sock) return;

  if (sock.connected) {
    sock.emit(event, data);
  } else {
    sock.once("connect", () => {
      sock.emit(event, data);
    });
  }
};

export { getSocket, safeEmit };
export default getSocket;
